import { useMemo } from 'react'
import { PaginatedResponse } from '@ca/common/types'
import { InfiniteData } from '@tanstack/react-query'

const useFlattenInfiniteData = <T>(
  data?: InfiniteData<PaginatedResponse<T>>
) => {
  const flatData = useMemo(
    () => data?.pages.flatMap((page) => page.data) || [],
    [data]
  )
  return flatData
}

export default useFlattenInfiniteData
